import { Input } from "components/Form/components/Input/Input";
import { FormComponentProps } from "../FormComponentProps";
import { CopyToClipboard } from "./CopyToClipboard";

export type CopyToClipboardFormComponentProps = {};

export const CopyToClipboardFormComponent = ({
    input,
    meta,
    fieldProps,
    fieldAttr,
}: FormComponentProps) => {
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <CopyToClipboard
                textToCopy={input.value ?? ""}
                identifier={input.name}
                input={input}
                attributes={fieldAttr}
                isReadonly={true}
            />
        </Input>
    );
};
